import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export default class IdCodeUtil {
	
	getControlNumber(code) {
		var multiplier1: Array<any> = [1, 2, 3, 4, 5, 6, 7, 8, 9, 1],
		multiplier2 = [3, 4, 5, 6, 7, 8, 9, 1, 2, 3],
		mod,
		total = 0;
		
		for (var i = 0; i < 10; i++) {
			total += code.charAt(i) * multiplier1[i];
		}
		mod = total % 11;
		
		total = 0;
		if (10 === mod) {
			for (i = 0; i < 10; i++) {
				total += code.charAt(i) * multiplier2[i];
			}
			mod = total % 11;
			if (10 === mod) {
				mod = 0;
			}
		}
		return mod;
	};
	
	isValid(code) {
		if (code.length !== 11) {
			return false;
		}
		var control: any = this.getControlNumber(code);
		if (control !== parseInt(code.charAt(10))) {
			return false;
		}
		
		var year: any = Number(code.substr(1, 2));
		var month: any = Number(code.substr(3, 2));
		var day: any = Number(code.substr(5, 2));
		var birthDate: any = this.getBirthday(code);
		return year === birthDate.getFullYear() % 100 && birthDate.getMonth() + 1 === month && day === birthDate.getDate();
	};
	
	getBirthday(code) {
		var year: any = parseInt(code.substring(1, 3)),
		month = parseInt(code.substring(3, 5).replace(/^0/, '')) - 1,
		day = code.substring(5, 7).replace(/^0/, ''),
		firstNumber = code.charAt(0);
		
		if (firstNumber === '1' || firstNumber === '2') {
			year += 1800;
		} else if (firstNumber === '3' || firstNumber === '4') {
			year += 1900;
		} else if (firstNumber === '5' || firstNumber === '6') {
			year += 2000;
		} else if (firstNumber === '7' || firstNumber === '8') {
			year += 2100;
		}
		
		return new Date(year, month, day);
	};
	
}